import React from 'react'

const ContactDetails = () => {
  return (
    <section className="space-section">
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-4">
            <a href="mailto:Business@srnext.in" className="counter-box flex flex-col items-center justify-center text-center gap-2 py-6 text-decoration-none" style={{ color: '#222' }}>
              <img src="/images/envelope.png" className="img-fluid mb-2" alt="envelop" style={{ width: 56, height: 56, objectFit: 'contain' }} />
              <span style={{ fontWeight: 600 }}>Business@srnext.in</span>
            </a>
          </div>
          <div className="col-md-4">
            <a href="tel:+919109109148" className="counter-box flex flex-col items-center justify-center text-center gap-2 py-6 text-decoration-none" style={{ color: '#222' }}>
              <img src="/images/phone-color.png" className="img-fluid mb-2" alt="phone" style={{ width: 56, height: 56, objectFit: 'contain' }} />
              <span style={{ fontWeight: 600 }}>+919109109148</span>
            </a>
          </div>
          <div className="col-md-4">
            <a href="skype:live:.cid.e11f1805bc4d0dfe?chat" className="counter-box visibity-none flex flex-col items-center justify-center text-center gap-2 py-6 text-decoration-none" style={{ color: '#222' }}>
              <img src="/images/skype-colored.png" className="img-fluid mb-2" alt="skype" style={{ width: 56, height: 56, objectFit: 'contain' }} />
              <span style={{ fontWeight: 600 }}>Skype</span>
            </a>
          </div>
          <div className="col-md-12 text-center mt-3">
					<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.030344631765!2d75.8953848!3d22.7605642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39631deea355612d%3A0x197533a01791b2e4!2sSR%20NEXT!5e0!3m2!1sen!2sin!4v1720956500000!5m2!1sen!2sin" width="100%" height="450" style={{border:0}}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactDetails
